import { MUTATION_TYPE, ACTION_TYPE, GETTER_TYPE } from './types'

/* eslint-disable no-param-reassign */
export default {
  state: {
    isEditMode: false,
    deleteConfirmationMessage: '', // причина снятия с публикации
    isContentSaved: true,
    // для отображения алерта о том, что изменения не сохранены и
    // вызова функций сохранения при опр действиях
    updater: 0,
    freeze: 0,
    errorWithChangingTextTestSubsection: false
  },

  mutations: {
    [MUTATION_TYPE.updateDeleteConfirmationMessage]: (state, message) => {
      state.deleteConfirmationMessage = message
    },
    [MUTATION_TYPE.updateContentSavedStatus]: (state, status) => {
      if (!state.freeze) {
        state.isContentSaved = Boolean(status)
      }
    },
    [MUTATION_TYPE.editMode]: (state, isEditMode) => {
      state.isEditMode = Boolean(isEditMode)
    },
    [MUTATION_TYPE.freezeUpdater]: (state, freeze) => {
      state.freeze = freeze
    },
    [MUTATION_TYPE.setErrorWithChangingTextTestSubsection]: (state, status) => {
      state.errorWithChangingTextTestSubsection = status
    },
    [MUTATION_TYPE.setUpdater]: (state, num) => {
      if (state.freeze <= 0) {
        state.updater = num
      } else {
        state.freeze -= 1
      }
    }
  },

  actions: {
    [ACTION_TYPE.updateTitle]: async (context, data) => context.commit('content/updateTitle', data, { root: true }),
    [ACTION_TYPE.updateEventSettings]: async (context, data) => context.commit('content/updateEventSettings', data, { root: true }),
    [ACTION_TYPE.updateEventVoting]: async (context, data) => context.commit('content/updateEventVoting', data, { root: true }),
    [ACTION_TYPE.updateShortDescription]: async (context, data) => context.commit('content/updateShortDescription', data, { root: true }),
    [ACTION_TYPE.updateFullDescription]: async (context, data) => context.commit('content/updateFullDescription', data, { root: true }),
    [ACTION_TYPE.updateDate]: async (context, data) => context.commit('content/updateDate', data, { root: true }),
    [ACTION_TYPE.updateImages]: async (context, data) => context.commit('content/updateImages', data, { root: true }),
    [ACTION_TYPE.updateVideos]: async (context, data) => context.commit('content/updateVideos', data, { root: true }),
    [ACTION_TYPE.updateUpdater]: (context, num) => {
      if (num === undefined) {
        num = context.getters.getUpdater + 1
      }
      context.commit('setUpdater', num)
    }
  },

  getters: {
    [GETTER_TYPE.isContentSaved]: (state) => state.isContentSaved,
    [GETTER_TYPE.isEditMode]: (state) => state.isEditMode,
    [GETTER_TYPE.getUpdater]: (state) => state.updater,
    [GETTER_TYPE.getFreeze]: (state) => state.freeze,
    [GETTER_TYPE.getErrorWithChangingTextTestSubsection]:
      (state) => state.errorWithChangingTextTestSubsection
  }
}
